import React, { useEffect, useRef } from "react";

const AdCard = ({ slot, style = {}, format = "auto", responsive = "true" }) => {
  const adRef = useRef(null);

  useEffect(() => {
    if (!adRef.current) return;
    try {
      if (window.adsbygoogle && !adRef.current.dataset.loaded) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        adRef.current.dataset.loaded = true;
      }
    } catch (e) {
      console.error("AdSense error:", e);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{
        display: "block",
        textAlign: "center",
        minHeight: "100px",
        ...style,
      }}
      data-ad-client="ca-pub-6684964226357133" // replace with your client ID
      data-ad-slot={slot} // your ad slot ID
      data-ad-format={format}
      data-full-width-responsive={responsive}
      ref={adRef}
    ></ins>
  );
};

export default AdCard;
